<script lang="jsx">
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import StatelessCheck from '@xhs/yam-beer/cmp/dataEntry/Checkbox/StatelessCheckbox.vue'

  export default {
    name: 'CheckOption',
    props: {
      label: {},
      checked: {
        type: Boolean,
        default: false,
      },
      indeterminate: {
        type: Boolean,
        default: false,
      },
      handleChange: {
        type: Function,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { attrs }) {
      return () => {
        const {
          label, checked, indeterminate, handleChange, disabled,
        } = props

        function onCheckboxChange(...args) {
          if (handleChange) {
            handleChange(...args)
          }
        }
        return (
          <NewBsBox
            bs={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              px: 12,
              cursor: 'pointer',
              '&[data-active]': {
                color: 'brand',
                '[data-nav]': {
                  fill: 'brand',
                },
              },
              '&:hover': {
                bg: disabled ? null : 'palette.tinBlue.base',
              },
            }}
            {...attrs}
          >
            <NewBsBox bs={{ display: 'flex', alignItems: 'flex-start' }}>
              <StatelessCheck
                bs={{ mr: 0 }}
                modelValue={checked}
                indeterminate={indeterminate}
                handleChange={onCheckboxChange}
                disabled={disabled} />
              <NewBsBox bs={{
                py: 6,
                fontSize: '14px',
              }}>
                {label}
              </NewBsBox>
            </NewBsBox>
            <BeerIcon
              icon="arrow-right-center-m"
              data-nav="true"
              size={14}
              bs={{ minWidth: 14, ml: 4, mt: 9 }}
              color="mute" />
          </NewBsBox>
        )
      }
    },
  }
</script>
